<template>
  <Head>
    <Link rel="icon" :href="currentFavicon" />
  </Head>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { Head, Link } from '#components';
import { onUnmounted } from 'vue';
import { getBrowser } from '@seb-platform/shared/utils/browser';

const favicons = [
  '/brand/favicon-animated/coffeebean.png',
  '/brand/favicon-animated/cup.png',
  '/brand/favicon-animated/heart.png',
];
const currentIndex = ref(0);
const currentFavicon = computed(() => favicons[currentIndex.value]);
const intervalId = ref<number>();

// Reference to the original elements to re-add upon unmount
const initialLinkEls = ref<NodeListOf<HTMLLinkElement>>();

onMounted(() => {
  const browser = getBrowser();

  if (browser === 'safari') {
    // Safari properly supports the .gif format for favicons
    return;
  }

  initialLinkEls.value = document.querySelectorAll('link[rel*="icon"]');
  initialLinkEls.value.forEach(el => el.remove()); // Remove all other favicons

  intervalId.value = window.setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % favicons.length;
  }, 900);
});

onUnmounted(() => {
  if (intervalId.value) {
    window.clearInterval(intervalId.value);
  }

  if (initialLinkEls.value) {
    initialLinkEls.value.forEach(el => document.head.appendChild(el));
  }
});
</script>

<style scoped></style>
